import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_MY_TEAM} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const MyTeam = lazy(() =>
  import('../../../screens/MyTeam')
    .then(module => ({default: module.MyTeam})));

const MyTeamNavigation = [
  {
    path: ROUTE_MY_TEAM,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <MyTeam />
      </Suspense>
    ),
  },
];

export default MyTeamNavigation;
